<template>
	<el-timeline-item v-bind="$attrs" v-on="$listeners">
	  <slot></slot>
	</el-timeline-item>
</template>
<script>
export default {
  name: "aia-timeline-item",
};
</script>